module.exports = __webpack_public_path__ + "img/banner.b2d8370f.png";